const ADMIN_URL = String(process.env.NEXT_PUBLIC_ADMIN_URL || '').replace(/\/$/, '')

export const EDITORIAL_PANEL_PATH = '/editorial-panel'

export const getEditorialPanelUrl = () => (ADMIN_URL ? `${ADMIN_URL}${EDITORIAL_PANEL_PATH}` : null)

// Wejście ze strony czasopisma: panel ustawia to czasopismo jako bieżące,
// a `intent=submit` od razu otwiera składanie manuskryptu.
export const getEditorialPanelJournalUrl = (journalUuid, intent = null) => {
  const baseUrl = getEditorialPanelUrl()

  if (!baseUrl || !journalUuid) return null

  const query = new URLSearchParams({ journal: journalUuid })
  if (intent) query.set('intent', intent)

  return `${baseUrl}?${query.toString()}`
}

// Wejście ze strony wydawcy (5664:19198): panel ustawia wydawcę jako bieżącego,
// a `intent=submit` od razu otwiera składanie propozycji wydawniczej.
export const getEditorialPanelPublisherUrl = (publisherUuid, intent = null) => {
  const baseUrl = getEditorialPanelUrl()

  if (!baseUrl || !publisherUuid) return null

  const query = new URLSearchParams({ publisher: publisherUuid })
  if (intent) query.set('intent', intent)

  return `${baseUrl}?${query.toString()}`
}
